import Container, {
  containerClasses,
  ContainerProps,
} from '@mui/material/Container';
import Grid, { gridClasses, GridProps } from '@mui/material/Grid';
import Paper, { paperClasses, PaperProps } from '@mui/material/Paper';
import Stepper, { stepperClasses, StepperProps } from '@mui/material/Stepper';
import { styled } from '@mui/material/styles';

import NEXT from '~/constants/NEXT';
import { ICustomTheme } from '~/styles/theme';

export const HEIGHT_HEADER = 72;
const HEIGHT_STEPPER = 150;
const HEIGHT_STEPPER_HIDDEN = 32;
const HEIGHT_ACTIONS = 75;

export const StyledContainer = styled(Container)<ContainerProps>({
  [`&.${containerClasses.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

export const StyledGridItemStepper = styled(Grid)<
  GridProps & { $hideStepper?: boolean }
>(({ $hideStepper }) => ({
  [`&.${gridClasses.item}`]: {
    alignItems: 'center',
    display: 'flex',
    height: $hideStepper ? HEIGHT_STEPPER_HIDDEN : HEIGHT_STEPPER,
    justifyContent: 'center',
    width: '100%',
  },
}));

export const StyledStepper = styled(Stepper)<StepperProps>(({ theme }) => ({
  [`&.${stepperClasses.root}`]: {
    width: '100%',
  },
  // TODO: Can this class name be imported from MUI?
  [`& svg.Mui-completed`]: {
    color: theme.palette.success.main,
  },
}));

export const StyledGridContainer = styled(Grid)<GridProps>({
  [`&.${gridClasses.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

export const StyledGridItemPaper = styled(Grid)<GridProps>(({ theme }) => ({
  [`&.${gridClasses.item}`]: {
    display: 'flex',
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(1, 1, 4, 1),
  },
}));

export const StyledGridItemChildren = styled(Grid)<
  GridProps & {
    $centerContent?: boolean;
    $hasActions: boolean;
    $hideStepper?: boolean;
  }
>(({ $centerContent, $hasActions, $hideStepper, theme }) => ({
  [`&.${gridClasses.item}`]: {
    alignItems: $centerContent ? 'center' : undefined,
    display: $centerContent ? 'grid' : 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: $centerContent ? 'center' : undefined,
    maxHeight: NEXT.IS_CLIENT
      ? window.innerHeight -
        HEIGHT_HEADER -
        ($hideStepper ? HEIGHT_STEPPER_HIDDEN : HEIGHT_STEPPER) -
        ($hasActions ? HEIGHT_ACTIONS : 0) -
        (theme as unknown as ICustomTheme).spacingPx * 4
      : undefined,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
}));

export const StyledGridItemActions = styled(Grid)<GridProps>(({ theme }) => ({
  [`&.${gridClasses.item}`]: {
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    height: HEIGHT_ACTIONS,
    justifyContent: 'space-between',
    padding: theme.spacing(0, 2),
  },
}));

export const StyledPaper = styled(Paper)<PaperProps>({
  [`&.${paperClasses.root}`]: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
});
